var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgEdit = function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.7,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.522 9.696V21H1V3.609h9.13"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.696 14.783 7.478 17.26l.522-4L12.74 5l2.695 1.565zM16.74 1.217c.738.435 1 1.392.564 2.13l-.913 1.61-2.695-1.566.956-1.652c.391-.696 1.348-.956 2.087-.522Z"
  }))));
};
export default SvgEdit;